// extracted by mini-css-extract-plugin
export var chatHtmlText = "_nf-2";
export var chatLink = "_nf-0";
export var chatText = "_nf-1";